import ExchangeBankContactModel from './exchange-bank-contact-model';
import ExchangeBankTypeModel from './exchange-bank-type-model';
import ExchangeStoreModel from './exchange-store-model';
import IntegrationPlayerModel from './generic/integration-player-model';
import { CHARGE_EMAIL_INITIAL_DAYS_DEFAULT, CHARGE_EMAIL_RESEND_DAYS_DEFAULT } from '../../../common/constants/exchangeBankConstants';

function _normalizeWorking(value) {
  if (value === undefined || value === null) return true;

  if (value === false || value === 'false' || value === 0) return false;

  return true;
}

export default class ExchangeBankModel {
  constructor(obj) {
    obj = obj || {};
    const contacts = obj.contacts?.map((contact) => new ExchangeBankContactModel(contact));
    const exchangeStores = obj.exchangeStores?.map((stores) => new ExchangeStoreModel(stores));

    this.id = obj.id != null ? Number(obj.id) : obj.id;
    this.cnpj = obj.cnpj;
    this.companyName = obj.companyName;
    this.fantasyName = obj.fantasyName;
    this.brandIcon = obj.brandIcon ?? null;
    this.brandLogo = obj.brandLogo ?? null;
    this.active = obj.active == undefined ? true : !!obj.active;
    this.exchangeType = new ExchangeBankTypeModel(obj.exchangeType);
    this.bank = parseInt(obj.bank) || undefined;
    this.agency = obj.agency;
    this.account = obj.account;
    this.pix = obj.pix;
    this.paymentAccount = obj.paymentAccount;
    this.linkedBank = parseInt(obj.linkedBank) || undefined;
    this.commission = obj.commission;
    this.stablecoinProfitPercentage = obj.stablecoinProfitPercentage !== null && obj.stablecoinProfitPercentage !== undefined 
      ? parseFloat(obj.stablecoinProfitPercentage) 
      : 100.00;
    this.exchangeContractCost = obj.exchangeContractCost;
    this.cep = obj.cep;
    this.country = obj.country;
    this.state = obj.state;
    this.city = obj.city;
    this.neighborhood = obj.neighborhood;
    this.street = obj.street;
    this.number = obj.number;
    this.complement = obj.complement;
    this.contacts = contacts?.length ? contacts : [];
    this.firstRegisterEmail = obj.firstRegisterEmail;
    this.secondRegisterEmail = obj.secondRegisterEmail;
    this.thirdRegisterEmail = obj.thirdRegisterEmail;
    this.firstRegisterPJEmail = obj.firstRegisterPJEmail;
    this.secondRegisterPJEmail = obj.secondRegisterPJEmail;
    this.thirdRegisterPJEmail = obj.thirdRegisterPJEmail;
    this.firstOperationEmail = obj.firstOperationEmail;
    this.secondOperationEmail = obj.secondOperationEmail;
    this.thirdOperationEmail = obj.thirdOperationEmail;
    this.firstOperationPJEmail = obj.firstOperationPJEmail;
    this.secondOperationPJEmail = obj.secondOperationPJEmail;
    this.thirdOperationPJEmail = obj.thirdOperationPJEmail;
    this.firstDocumentationEmail = obj.firstDocumentationEmail;
    this.secondDocumentationEmail = obj.secondDocumentationEmail;
    this.thirdDocumentationEmail = obj.thirdDocumentationEmail;
    this.firstDocumentationPJEmail = obj.firstDocumentationPJEmail;
    this.secondDocumentationPJEmail = obj.secondDocumentationPJEmail;
    this.thirdDocumentationPJEmail = obj.thirdDocumentationPJEmail;
    this.firstDiDueEmail = obj.firstDiDueEmail;
    this.secondDiDueEmail = obj.secondDiDueEmail;
    this.thirdDiDueEmail = obj.thirdDiDueEmail;
    this.firstDiDuePJEmail = obj.firstDiDuePJEmail;
    this.secondDiDuePJEmail = obj.secondDiDuePJEmail;
    this.thirdDiDuePJEmail = obj.thirdDiDuePJEmail;
    this.firstFinancialEmail = obj.firstFinancialEmail;
    this.secondFinancialEmail = obj.secondFinancialEmail;
    this.thirdFinancialEmail = obj.thirdFinancialEmail;
    this.firstFinancialPJEmail = obj.firstFinancialPJEmail;
    this.secondFinancialPJEmail = obj.secondFinancialPJEmail;
    this.thirdFinancialPJEmail = obj.thirdFinancialPJEmail;
    this.exchangeStores = exchangeStores?.length ? exchangeStores : [];
    this.useInOutLimit = obj.useInOutLimit;
    this.useUsdLimit = obj.useUsdLimit;
    this.useUsdExchangeContract = obj.useUsdExchangeContract;
    this.exchangeContractCashBack = obj.exchangeContractCashBack;
    this.externalId = obj.externalId;
    this.useRegisterForm = obj.useRegisterForm;
    this.pfRegisterFormTemplate = obj.pfRegisterFormTemplate;
    this.pjRegisterFormTemplate = obj.pjRegisterFormTemplate;
    this.signatureService = obj.signatureService;
    this.isDigitalCurrency = !!obj.isDigitalCurrency;
    this.enabledInternationalPaymentMethods = Array.isArray(obj.enabledInternationalPaymentMethods)
      ? obj.enabledInternationalPaymentMethods
      : null;
    this.bankStartTime = obj.bankStartTime || null;
    this.bankEndTime = obj.bankEndTime || null;
    this.liquidationConfigs = Array.isArray(obj.liquidationConfigs) ? obj.liquidationConfigs : [];
    this.working = _normalizeWorking(obj.working);
    this.workingDescription = obj.workingDescription ?? '';
    this.integrationPlayer = new IntegrationPlayerModel(obj.integrationPlayer);
    this.customerIntegration = !!obj.customerIntegration;
    this.enableDuimpChargeEmail = !!obj.enableDuimpChargeEmail;
    this.chargeEmailInitialDays = obj.chargeEmailInitialDays ?? CHARGE_EMAIL_INITIAL_DAYS_DEFAULT;
    this.chargeEmailResendDays = obj.chargeEmailResendDays ?? CHARGE_EMAIL_RESEND_DAYS_DEFAULT;
    this.createdAt = obj.createdAt;
    this.updatedAt = obj.updatedAt;
  }
}
